import React from 'react';
import "./PricingCard.css";
import { Link } from 'react-router-dom';

function PricingCards() {
  return (
    <div className="pricing">
        <h1 class="project-heading">Pricing</h1>
        <div className="card-container">
            <div className="card">
                <h3>- WEB ESSENTIALS -</h3>
                 <span className="bar"></span>
                 <p className="btc">$ 4.99</p>
                 <p>- 2 Days -</p>
                 <p>- 3 Pages -</p>
                 <p>- Featured -</p>
                 <p>- Responsive Design -</p>
                 <Link to="/contact" className="btn btn-purchase">
                  PURCHASE NOW
                 </Link>
            </div>
            <div className="card">
                <h3>- WEB PRO -</h3>
                 <span className="bar"></span>
                 <p className="btc">$ 9.99 </p>
                 <p>- 2 Days -</p>
                 <p>- 5 Pages -</p>
                 <p>- SEO -</p>
                 <p>- Custom Design -</p>
                 <Link to="/contact" className="btn btn-purchase">
                  PURCHASE NOW
                 </Link>
            </div>
            <div className="card">
                <h3>- WEB ELITE -</h3>
                 <span className="bar"></span>
                 <p className="btc">$ 19.99 </p>
                 <p>- 3 Days -</p>
                 <p>- 10 Pages -</p>
                 <p>- Content Upload -</p>
                 <p>- Source Code -</p>
                 <Link to="/contact" className="btn btn-purchase">
                  PURCHASE NOW
                 </Link>
            </div>
            </div>
    </div>
  )
}

export default PricingCards